import { default as Locale } from '../utils/Locale';

export class State {
    id?: number;
    siteId: number;
    /** UUID of the entity the state item belongs to. */
    item: string;
    /** E.g: AutoFilterVersion, PowerState etc. */
    name: string;
    /** The actual value of the state item. */
    state: string;
    /** ISO timestamp. Note: Currently we don't convert the incoming date string sent by the API from string to Date */
    updated: string;
    device?: string;
    /** Hint text, where the item was generated/overridden if it was. */
    mockSource?: string;
}

export enum siteMode {
    INSTALLER = "INSTALLER",
    NORMAL = "NORMAL",
    SERVICE = "SERVICE",
    FACTORY = "FACTORY"
}

export type PlatformCapabilities = {
    Controllers: PlatformCapabilitiesControllers[]
}
export type PlatformCapabilitiesControllers = {
    ControllerUUID: string;
    Modules: PlatformCapabilitiesModules[]
}
export type PlatformCapabilitiesModules = {
    Attached: boolean,
    ModuleNumber: string, // E.g: "1", or for a light river: "91-42-11-A0-3B"
    PortTypes: {
        Actuator?: PlatformCapabilitiesPorts[],
        Bluetooth?: PlatformCapabilitiesPorts[],
        Bus?: PlatformCapabilitiesPorts[],
        ChemistryORP?: PlatformCapabilitiesPorts[],
        ChemistryPH?: PlatformCapabilitiesPorts[],
        FlowSwitch?: PlatformCapabilitiesPorts[],
        HighVoltage?: PlatformCapabilitiesPorts[],
        InterfaceButtons?: PlatformCapabilitiesPorts[],
        LightDriverLowVoltage?: PlatformCapabilitiesPorts[],
        LowVoltage?: PlatformCapabilitiesPorts[],
        Ma?: PlatformCapabilitiesPorts[],
        Thermistor?: PlatformCapabilitiesPorts[],
    },
    ModuleData: {
        // Poolside Attendant
        BoardRevision: string, // E.g: 2,
        ModuleNumber: number,
        McuVersion: string, // E.g: "022"
        Serial: string,
    } | null,
    ModulePortInformation: {
        // Hayward HUA Light Driver
        Bus: number,
        BusClass: string, // E.g: "HaywardHUABus"
        AddressUniqueType: string, // E.g: "All"
    } | null,
    Type: string, // E.g: "POOLSIDE", "HAYWARD_HUA_LIGHT_DRIVER"
    UniqueBusIdentifier: string | null, // E.g: "91-42-11-A0-3B"
}
export type PlatformCapabilitiesPorts = {
    /** Note: Bluetooth does not use PortNumber, marking prop as optional */
    PortNumber?: number
}
export enum PlatformCapabilitiesModulesPortTypes {
    Actuator = "Actuator",
    Bus = "Bus",
    ChemistryORP = "ChemistryORP",
    ChemistryPH = "ChemistryPH",
    FlowSwitch = "FlowSwitch",
    HighVoltage = "HighVoltage",
    InterfaceButtons = "InterfaceButtons",
    LightDriverLowVoltage = "LightDriverLowVoltage",
    LowVoltage = "LowVoltage",
    Ma = "Ma",
    Thermistor = "Thermistor",
    Bluetooth = "Bluetooth",
}

export type ModeExitStrategy = {
    /** Enum with possible options as “ANYONE, SAME_USER, LOCAL_ONLY” */
    modeExitStrategy: exitModeStrategies,
    /** User UUID that placed the system into the mode */
    modeEnteredByUser: string,
    /** Dateteime when mode was entered */
    modeEnterTime: Date,
}

export enum exitModeStrategies {
    /** This is similar to what we do now. Anyone will be able to exit installer mode.*/
    ANYONE = "ANYONE",
    /** This setting will make sure that the only way to exit installer mode is to have the exit performed by the same user who entered installer mode or a member of the same organization.*/
    SAME_USER = "SAME_USER",
    /** This setting will only be available from the local UI and disallow exiting out of installer mode using remote means.*/
    LOCAL_ONLY = "LOCAL_ONLY",
};

export type installeModeUserInfo = {
    /** Current user is allowed to exit IM */
    isCurrentUserAllowedToExit: boolean,
    /** Info of the user who entered IM */
    userEnteredImFirstName?: string,
    userEnteredImLastName?: string,
    siteOrganizationName: string,
}
export type getInstallerModeUserInfoCb = (userUuid: string) => Promise<installeModeUserInfo>;
